export default {
  name: 'addressBookVisitor',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest('/sites/visitors/addressbook/', 'PUT', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `sites-siteid-view-visitors`, params: { siteid: data.siteid } })
  }
}
